<template>
  <div class="normal-header-box show-flex-box-r show-flex-center" @click="slideUpSearchBox()">
    <dl class="show-flex-box-r">
      <dt class="show-flex-box-r">
        <h1 class="show-flex-box-r show-flex-center" @click="opendHomePages('index')">
          <img src="@/assets/logo.png" alt="中国书法" />
        </h1>
        <ul class="nav-content-list-box show-flex-box-r">
          <li
            class="show-flex-box-r show-flex-center"
            :class="{'tag-selected': item.type == curRoutePathName}"
            v-for="(item,index) in navClassList"
            :key="index"
            @click="opendHomePages(item.type)"
          >
            <strong>{{item.name}}</strong>
          </li>
        </ul>
      </dt>
      <dd class="show-flex-box-r">
        <div class="external-link show-flex-box-r show-flex-center">
          <span @click="openExternal('ccpdo')">数字传播应用</span>
          <span @click="openExternal('zgsftv')">书法网络平台</span>
        </div>
        <div class="header-search-box show-flex-box-r">
          <span class="show-flex-box-r">
            <input
              type="text"
              placeholder="搜索商品、课程、名家"
              @click.stop="slideDownSearchBox()"
              @blur="searchBoxBlur()"
              @keyup.enter="routeToSearchResaultPage()"
              v-model="searchContent"
            />
            <em @click="routeToSearchResaultPage()"></em>
          </span>
          <div
            class="search-box show-flex-box-r"
            :class="{'search-blur': searchBoxFocus}"
            @click.stop="clickSearchBox()"
          >
            <dl class="show-flex-box-c">
              <dt class="show-flex-box-c">
                <span>热门搜索</span>
                <ul class="show-flex-box-r" v-if="navClassList.length > 0">
                  <li v-for="(item,index) in hotSearch" :key="index">
                    <strong class="hide-line1" @click="selectSearchContent(item)">{{item.word}}</strong>
                  </li>
                </ul>
                <div v-else>暂无热门搜索</div>
              </dt>
              <dd class="show-flex-box-c">
                <span class="show-flex-box-r">
                  <strong>历史搜索</strong>
                  <span @click="deletSearchHistory()"></span>
                </span>
                <ul class="show-flex-box-r" v-if="searchHistory.length > 0">
                  <li v-for="(item,index) in searchHistory" :key="index">
                    <strong class="hide-line1" @click="selectSearchContent(item)">{{item.word}}</strong>
                  </li>
                </ul>
                <div v-else>暂无搜索历史</div>
              </dd>
            </dl>
          </div>
        </div>
        <dl class="header-login-register-box">
          <dd v-if="isLogined" class="header-isLogined-box">
            <h1 class="show-flex-box-r show-flex-center">
              <img :src="userInfo.avatar" alt="中国书法" />
            </h1>
            <div class="header-option-box">
              <div class="show-flex-box-c">
                <div class="hide-line1">{{userInfo.showname}}</div>
                <ul class="show-flex-box-c">
                  <li @click="openNextPage('/web/my/personal/message_center')">
                    <span>消息中心（{{startupData ? startupData.un_read_message_count : 0}}）</span>
                  </li>
                  <li @click="openNextPage('/web/my/personal/personal_data')">
                    <span>个人中心</span>
                  </li>
                  <li @click="openNextPage('/web/my/personal/my_collect')">
                    <span>我的收藏</span>
                  </li>
                  <li @click="openNextPage('/web/my/store/order_list')">
                    <span>我的订单（{{startupData ? startupData.order_num : 0}}）</span>
                  </li>
                  <li @click="openNextPage('/web/my/personal/my_wallet')">
                    <span>我的钱包（¥&nbsp;{{userInfo.wallet && userInfo.wallet > 0? userInfo.wallet : '0.00'}}）</span>
                  </li>
                  <li>
                    <span @click="logout">退出登录</span>
                  </li>
                </ul>
              </div>
            </div>
          </dd>
          <dt class="show-flex-box-r" v-else>
            <strong @click="getClickInfo('login')">登录</strong>
            <strong @click="getClickInfo('register')">注册</strong>
          </dt>
        </dl>
      </dd>
    </dl>
  </div>
</template>

<script>
// import {LoginUser} from "@/model/login_user.js";
import WebIM from "@/utils/WebIM";
import regex from "@/filter/regex";
import login from "@/views/login/login";
import register from "@/views/login/register";
import {setSearchHistory,getSearchHistory,removeSearchHistory} from '@/utils/auth'

export default {
  name: "home",
  data() {
    return {
      navClassList: [
        { type: "index", name: "首页" },
        { type: "courseHome", name: "课程" },
        // { type: "mastersHome", name: "名家" },
        // { type: "storeHome", name: "商城" }
      ],
      isLogined: false,
      userInfo: false,
      searchBoxFocus: false,
      isClickSearchBox: false,
      curRoutePathName: "",
      searchContent: "",
      easelogined: false,
      hotSearch: [],
      startupData: null,
      searchHistory: []
    };
  },
  components: {
    login,
    register
  },
  computed: {
    listenToken: function() {
      return this.$store.state.token;
    },
    listenStartupData: function() {
      return this.$store.state.startup;
    },
    listenUserInfo: function() {
      return this.$store.state.user;
    },
    listenWebImErrorCode: function() {
      return this.$store.state.webImErrorCode;
    },
    listenLoginPopShowStatus: function() {
      return this.$store.state.loginPopShowStatus;
    }
  },
  created() {
    this.curRoutePathName = this.$route.name;
    this.checkUserLoginStatus();
    this.startupData = this.listenStartupData;
    this.reqSearchHistory();
  },
  mounted() {
    this.getHotSearchList();
    this.getStartupData();
  },
  methods: {
    reqSearchHistory: function() {
      var saveStorage = getSearchHistory();

      if (saveStorage && saveStorage.length > 0) {
        this.searchHistory = saveStorage;
      }
    },
    saveHistoryKeyWord: function(keyword) {
      if (!keyword) {
        return;
      }
      
      var keywordObj = this.checkHaskeyword(keyword);
      var curTime = this.getCurrentTimestamp();
      var saveObj = {
        word: keyword,
        timestamp: curTime
      };

      if (keywordObj) {
        var index = keywordObj.index;
        this.searchHistory.splice(index,1);
      }

      this.searchHistory.unshift(saveObj);
      this.saveSearchHistory(this.searchHistory);
    },
    getCurrentTimestamp: function() {
      var timeStamp = new Date().getTime();
      return timeStamp;
    },
    checkHaskeyword: function(keyword) {
      var hList = this.searchHistory;

      for(var i=0; i<hList.length; ++i) {
        var singleObj = hList[i];

        if (singleObj.word == keyword) {
          singleObj.index = i;
          return singleObj;
        }
      }

      return false;
    },
    saveSearchHistory: function(historyList) {
      if (historyList) {
        setSearchHistory(historyList);
      } else {
        removeSearchHistory();
      }
    },
    getStorageSearchHistory: function() {
      getSearchHistory();
    },
    checkUserLoginStatus: function() {
      let userToken = this.$store.state.token;
      let tokenStatus = regex.isTrueResult(userToken);

      if (tokenStatus) {
        this.getUserInfo();
        this.getStartupData();
        this.checkUserStatusThenGetUserInfo();
      }
    },
    checkEaseChatHandleByUserInfo: function() {
      var userInfo = this.listenUserInfo;
      var easemobUser = userInfo ? userInfo.easemob_user : null;
      if (easemobUser) {
        this.easeChatLogin(easemobUser);
      } else {
        if (this.easelogined) {
          this.easeChatLogout();
        }
      }
    },
    easeChatLogin: function(easemobUser) {
      if (this.easelogined) {
        return;
      }

      let easeName = easemobUser.easemob_username;
      let easePwd = easemobUser.easemob_pwd;
      let options = {
        apiUrl: WebIM.config.apiURL,
        user: easeName,
        pwd: easePwd,
        appKey: WebIM.config.appkey,
        success: function(token) {
          console.log("--------登录成功了------------");
        },
        error: function(err) {
          console.log("--------登录失败了------------");
        }
      };

      WebIM.conn.open(options);
      this.easelogined = true;
    },
    easeChatLogout: function() {
      WebIM.conn.close();
    },
    nextHandleByWebImErrorCode: function() {
      var errorCode = this.listenWebImErrorCode;

      switch (errorCode) {
        case 206:
          this.easeChatLogout();
          this.easelogined = false;
          this.checkEaseChatHandleByUserInfo();
          break;
      }
    },
    getHotSearchList: function() {
      this.$client
        .getHotSearchList()
        .then(res => {
          if (res.code == "200") {
            this.hotSearch = res.data.list;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    getStartupData: function() {
      this.$client
        .getStartupData()
        .then(res => {
          if (res.code == "200") {
            this.startupData = res.data;
            this.$store.commit("GET_START_UP", this.startupData);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    routeToSearchResaultPage: function() {
      var _this = this;
      var path = "";
      var searchKeyWord = this.searchContent;

      switch (this.curRoutePathName) {
        case "index":
          path = "/web/home/home_search_result";
          break;
        case "courseHome":
          path = "/web/course/course_search_result";
          break;
        case "mastersHome":
          path = "/web/logicians/masters_search_result";
          break;
        case "storeHome":
          path = "/web/store/store_search_result";
          break;
        default:
          path = "/web/home/home_search_result";
          break;
      }

      this.saveHistoryKeyWord(searchKeyWord);
      this.$router.push({
        path: path,
        query: { searchContent: searchKeyWord}
      });

      this.searchContent = "";
    },
    deletSearchHistory: function() {
      this.searchHistory = [];
      this.saveSearchHistory();
    },
    getUserInfo: function() {
      let _this = this;

      this.$client
        .getUserInfo()
        .then(res => {
          if (res.code == 200) {
            _this.userInfo = res.data;
            let curUserInfo = _this.saveUserInfo(res.data);
            _this.$store.commit("GET_USER", curUserInfo);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 保存用户信息
    saveUserInfo: function(userObj) {
      let userInfo;
      userInfo = {
        showname: userObj.showname,
        avatar: userObj.avatar.o,
        birthday: userObj.birthday,
        gender: userObj.gender,
        province: userObj.province,
        city: userObj.city,
        county: userObj.county,
        wallet: userObj.wallet,
        easemob_user: userObj.easemob_user,
        email: userObj.email,
        phone: userObj.phone,
        has_password: userObj.has_password,
        has_pay_password: userObj.has_pay_password,
        is_bind_weixin: userObj.is_bind_weixin,
        is_bind_qq: userObj.is_bind_qq,
        is_bind_weibo: userObj.is_bind_weibo
      };

      return userInfo;
    },
    checkUserStatusThenGetUserInfo: function() {
      let userStore = this.$store.state.user;
      let userStatus = regex.isTrueResult(userStore);

      if (userStatus) {
        this.isLogined = regex.isTrueResult(this.$store.state.loginStatus);
        this.userInfo = this.formatUserInfoByType(userStore);
        this.$store.dispatch("setlocalEncryptPublicKey");
      } else {
        this.userInfo = {};
        this.isLogined = regex.isTrueResult(this.$store.state.loginStatus);
      }
    },
    //用户信息数据类型转换
    formatUserInfoByType: function(userStore) {
      let dataType = typeof userStore;
      let userObj = userStore;

      return userObj;
    },
    getClickInfo: function(type) {
      if (type == "login") {
        this.$parent.$refs.login.colseLoginWin();
      } else {
        this.$parent.$refs.register.closeRegisterPop();
      }
    },
    setLoginPopShowStatus: function() {
      var showStatus = this.listenLoginPopShowStatus;
      
      if (showStatus) {
        this.$parent.$refs.login.colseLoginWin();
      } 
    },
    opendHomePages: function(index) {
      if (index == "index") {
        this.$router.push({ path: "/web/home" });
      } else if (index == "courseHome") {
        this.$router.push({ path: "/web/course/course_home" });
      } else if (index == "mastersHome") {
        this.$router.push({ path: "/web/logicians/masters_home" });
      } else {
        this.$router.push({ path: "/web/store/store_home" });
      }
    },
    logout: function() {
      this.$store.commit("LOGOUT");
    },
    openNextPage: function(path) {
      this.$router.push({ path: path });
    },
    slideDownSearchBox: function() {
      this.searchBoxFocus = true;
    },
    slideUpSearchBox: function() {
      this.searchBoxFocus = false;
    },
    openExternal(type) {
      const linkMap = {
        ccpdo: 'https://www.ccpdo.cn',
        zgsftv: 'https://zgsftv.com'
      };

      !!linkMap[type] && window.open(linkMap[type],'_blank');
    },
    searchBoxBlur: function() {
      var _this = this;

      setTimeout(() => {
        if (_this.isClickSearchBox) {
          _this.isClickSearchBox = false;
          return;
        }
        _this.searchBoxFocus = false;
      }, 300);
    },
    clickSearchBox: function() {
      this.isClickSearchBox = true;
    },
    selectSearchContent: function(item) {
      var searchKeyWord = item.word;

      this.searchContent = searchKeyWord;
      this.saveHistoryKeyWord(searchKeyWord);
      this.slideUpSearchBox();
      this.routeToSearchResaultPage();
    }
  },
  watch: {
    listenToken: function() {
      let tokenStatus = regex.isTrueResult(this.listenToken);
      if (tokenStatus) {
        this.getUserInfo();
        this.getStartupData();
      } else {
        this.isLogined = false;
      }
    },
    listenUserInfo: function() {
      this.userInfo = this.listenUserInfo;

      this.checkEaseChatHandleByUserInfo();
      this.checkUserStatusThenGetUserInfo();
    },
    listenWebImErrorCode: function() {
      this.nextHandleByWebImErrorCode();
    },
    listenStartupData: function() {
      this.startupData = this.listenStartupData;
    },
    listenLoginPopShowStatus: function() {
      this.setLoginPopShowStatus();
    },
    // listenChatMessage: function() {
    //   // alert(JSON.stringify(this.listenChatMessage));
    // },
    $route: function(to, from) {
      this.curRoutePathName = to.name;
    }
  }
};
</script>
<style lang="less" scoped>
//selection字体样式  start
.selection-font-style( @size; @weight; @height; @color ) {
  display: block;
  font-size: @size;
  font-weight: @weight;
  line-height: @height;
  color: @color;
  word-break: break-all;
  font-family: SourceHanSerifCN-Medium, SourceHanSerifCN;
}

.normal-header-box {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 56px;
  z-index: 99;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background: #302929;
  & > dl {
    height: 100%;
    flex-shrink: 0;
    justify-content: center;
    align-items: center;
    & > dt {
      height: 100%;
      & > h1 {
        width: 180px;
        height: 100%;
        flex-shrink: 0;
        margin-right: 50px;
        cursor: pointer;
        & > img {
          display: block;
          width: 100%;
        }
      }
      .nav-content-list-box {
        flex-shrink: 0;
        -webkit-box-pack: start;
        justify-content: flex-start;
        -webkit-box-align: center;
        align-items: center;
        height: 100%;
        & > li {
          padding-left: 25px;
          padding-right: 25px;
          height: 100%;
          cursor: pointer;
          & > strong {
            display: block;
            font-size: 14px;
            line-height: 18px;
            font-family: SourceHanSerifCN-Medium, SourceHanSerifCN;
            font-weight: 500;
            color: #aca9a9;
          }
        }
        & > .tag-selected {
          & > strong {
            color: #fff;
          }
        }
        & > li:hover {
          & > strong {
            color: #fff;
          }
        }
      }
    }
    & > dd {
      -webkit-box-pack: end;
      justify-content: flex-end;
      -webkit-box-align: center;
      align-items: center;
      .external-link {
        padding-left: 50px;
        margin-right: 20px;
        &>span {
          border-left: 2px solid #aca9a9;
          white-space: nowrap;
          padding-left: 10px;
          margin-right: 10px;
          font-size: 14px;
          font-family: SourceHanSerifCN-Medium, SourceHanSerifCN;
          font-weight: 500;
          cursor: pointer;
          color: #aca9a9;
          &:last-child {
            margin-right: 0;
          }
          &:hover {
            text-decoration: underline;
            color: #fff;
          }
        }
      }
      .header-search-box {
        position: relative;
        width: 258px;
        margin-right: 40px;
        -webkit-box-align: center;
        align-items: center;
        & > span {
          -webkit-box-flex: 1;
          flex-grow: 1;
          height: 18px;
          padding: 6px 10px;
          border-radius: 2px;
          background: #403d3d;
          & > input {
            display: block;
            width: 207px;
            font-size: 12px;
            font-family: SourceHanSerifCN-Medium, SourceHanSerifCN;
            font-weight: 500;
            line-height: 21px;
            color: #9f9d9d;
          }
          & > em {
            display: block;
            width: 21px;
            height: 21px;
            margin-left: 10px;
            flex-shrink: 0;
            cursor: pointer;
            background: url("../../assets/header/search_icon_1.png") center
              center no-repeat;
            background-size: 21px 21px;
          }
        }
        & > .search-box {
          overflow: hidden;
          position: absolute;
          top: 50px;
          left: 0;
          width: 260px;
          height: 0;
          background: #fff;
          -webkit-transition: height 0.2s;
          transition: height 0.2s;
          & > dl {
            -webkit-box-flex: 1;
            flex-grow: 1;
            padding: 14px 16px;
            & > dt {
              width: 100%;
              & > span {
                .selection-font-style(14px; 500; 20px; #302929);
                padding-bottom: 5px;
              }
              & > ul {
                overflow: scroll;
                width: 100%;
                height: 64px;
                flex-wrap: wrap;
                margin-right: -5px;
                & > li {
                  width: 30%;
                  height: 27px;
                  margin-right: 5px;
                  margin-bottom: 5px;
                  cursor: pointer;
                  & > strong {
                    -webkit-transition: all 0.2s;
                    transition: all 0.2s;
                    padding: 5px 10px;
                    background: #f4f3f0;
                    .selection-font-style(14px; 500; 17px; #837e7e);
                    text-align: center;
                  }
                }
                & > li:hover {
                  & > strong {
                    -webkit-transition: all 0.2s;
                    transition: all 0.2s;
                    background: #e9e7e1;
                    color: #302929;
                  }
                }
              }
              & > ul::-webkit-scrollbar {
                display: none;
                width: 0;
                height: 0;
                background-color: none;
              }
              // 定义滚动条轨道 内阴影+圆角
              & > ul::-webkit-scrollbar-track {
                width: 0;
                background-color: none;
              }
              // 定义滑块 内阴影+圆角
              & > ul::-webkit-scrollbar-thumb {
                border-radius: 0;
                background-color: none;
              }

              & > div {
                .selection-font-style(14px; 500; 64px; #837e7e);
                text-align: center;
              }
            }
            & > dd {
              width: 100%;
              margin-top: 8px;
              & > span {
                width: 100%;
                -webkit-box-pack: justify;
                justify-content: space-between;
                -webkit-box-align: center;
                align-items: center;
                & > strong {
                  .selection-font-style(14px; 500; 20px; #302929);
                  padding-bottom: 5px;
                }
                & > span {
                  width: 14px;
                  height: 14px;
                  background: url("../../assets/common/delete_icon.png")
                    no-repeat center center;
                  background-size: 14px 14px;
                  cursor: pointer;
                }
              }
              & > ul {
                overflow: scroll;
                width: 100%;
                height: 64px;
                flex-wrap: wrap;
                margin-right: -5px;
                & > li {
                  width: 30%;
                  height: 27px;
                  cursor: pointer;
                  margin-right: 5px;
                  margin-bottom: 5px;
                  & > strong {
                    -webkit-transition: all 0.2s ease-in-out;
                    transition: all 0.2s ease-in-out;
                    padding: 5px 10px;
                    background: #f4f3f0;
                    text-align: center;
                    .selection-font-style(14px; 500; 17px; #837e7e);
                  }
                }
                & > li:hover {
                  & > strong {
                    -webkit-transition: all 0.2s ease-in-out;
                    transition: all 0.2s ease-in-out;
                    background: #e9e7e1;
                    color: #302929;
                  }
                }
              }
              & > ul::-webkit-scrollbar {
                display: none;
                width: 0;
                height: 0;
                background-color: none;
              }
              // 定义滚动条轨道 内阴影+圆角
              & > ul::-webkit-scrollbar-track {
                width: 0;
                background-color: none;
              }
              // 定义滑块 内阴影+圆角
              & > ul::-webkit-scrollbar-thumb {
                border-radius: 0;
                background-color: none;
              }
              & > div {
                .selection-font-style(14px; 500; 64px; #837e7e);
                text-align: center;
              }
            }
          }
        }
        & > .search-blur {
          width: 258px;
          height: 214px;
          -webkit-transition: height 0.2s ease-in-out;
          transition: height 0.2s ease-in-out;
          border: 1px solid #ccc;
        }
      }
      & > .header-login-register-box {
        & > dt {
          flex-shrink: 0;
          & > strong {
            font-size: 14px;
            font-family: SourceHanSerifCN-Medium, SourceHanSerifCN;
            font-weight: 500;
            margin-right: 20px;
            white-space: nowrap;
            cursor: pointer;
            color: #aca9a9;
          }
          & > strong:hover {
            color: #fff;
          }
          & > strong:last-child {
            margin-right: 0;
          }
        }
        & > .header-isLogined-box {
          position: relative;
          flex-shrink: 0;
          & > h1 {
            overflow: hidden;
            width: 28px;
            height: 28px;
            flex-shrink: 0;
            margin-left: 41px;
            border-radius: 100%;
            border: 1px solid #fff;
            cursor: pointer;
            & > img {
              display: block;
              width: 100%;
            }
          }
          .header-option-box {
            overflow: hidden;
            position: absolute;
            top: 28px;
            right: 0;
            width: 200px;
            height: 0;
            -webkit-transition: height 0.2s ease-in-out;
            transition: height 0.2s ease-in-out;
            z-index: 0;
            & > div {
              margin-top: 20px;
              background: #fff;
              border: 1px solid #ccc;
              & > div {
                .selection-font-style(18px; 500; 60px; #302929);
                border-bottom: 1px solid #eee;
                margin-left: 15px;
                margin-right: 15px;
              }
              & > ul {
                & > li {
                  padding-left: 15px;
                  padding-right: 15px;
                  cursor: pointer;
                  & > span {
                    .selection-font-style(13px; 400; 38px; #837e7e);
                  }
                }
                & > li:nth-child(5) span {
                  border-bottom: 1px solid #eee;
                }
                & > li:hover {
                  background: #f9f8f8;
                  & > span {
                    color: #e60012;
                  }
                }
              }
            }
          }
        }
        .header-isLogined-box:hover {
          .header-option-box {
            height: 312px;
            -webkit-transition: height 0.2s ease-in-out;
            transition: height 0.2s ease-in-out;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/publick/header_cpn.vue